import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default async function updateSubCollection(body, projectUrl = getProject(), httpRequest = axios) {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Date.now()}`
  };

  const response = await httpRequest({
    url: `${projectUrl}/saveSubCollectionV2`,
    method: 'POST',
    headers: config,
    data: JSON.stringify(body)
  })

  return response
}
